import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

const featured = animeList.filter((a) => a.banner && a.rating >= 9);

interface Slide {
  id: string;
  to: string;
  title: string;
  summary: string;
  image: string;
  badge: string;
}

const slides: Slide[] = [
  ...featured.slice(0, 3).map((a) => ({
    id: a.id,
    to: `/detail/${a.id}`,
    title: a.title,
    summary: a.summary,
    image: a.banner,
    badge: '编辑推荐',
  })),
  {
    id: 'news-001',
    to: '/news/news-001',
    title: '《星海旅人》第二季正式定档',
    summary: '全新剧情 PV 与主视觉图同步公开，明年一月正式开播。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20anime%20scene%20of%20a%20space%20traveler%20girl%20on%20a%20starship%20deck%20watching%20a%20giant%20purple%20nebula%2C%20dramatic%20rim%20light%2C%20illustration&width=1200&height=675&seq=hero-news-01&orientation=landscape',
    badge: '热门资讯',
  },
  {
    id: 'news-004',
    to: '/news/news-004',
    title: '《深海回响》获年度最佳剧情动画提名',
    summary: '凭借压抑而精致的叙事氛围，成功入围两项年度大奖。',
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20anime%20scene%20of%20a%20submarine%20gliding%20through%20a%20glowing%20deep%20sea%20trench%2C%20teal%20bioluminescence%2C%20cinematic%20illustration&width=1200&height=675&seq=hero-news-02&orientation=landscape',
    badge: '行业动态',
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (i: number) => setCurrent((i + slides.length) % slides.length);

  if (slides.length === 0) {
    return (
      <div className="w-full h-[320px] md:h-[520px] bg-primary-900 flex items-center justify-center text-background-100">
        暂无推荐内容
      </div>
    );
  }

  return (
    <section className="relative w-full h-[380px] md:h-[560px] overflow-hidden bg-primary-950">
      {slides.map((slide, i) => (
        <Link
          to={slide.to}
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 cursor-pointer ${i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 妖精动漫`}
            className="w-full h-full object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/55 to-primary-950/15"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent"></div>
          <div className="relative w-full h-full px-4 md:px-8 flex flex-col justify-end pb-14 md:pb-20 max-w-3xl">
            <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-4">
              <i className="ri-fire-fill"></i>
              {slide.badge}
            </span>
            <h2 className="text-2xl md:text-5xl font-bold text-background-50 leading-tight drop-shadow">
              {slide.title}
            </h2>
            <p className="mt-3 md:mt-4 text-sm md:text-lg text-background-200 max-w-xl line-clamp-2">
              {slide.summary}
            </p>
            <span className="mt-5 inline-flex w-fit items-center gap-1.5 h-10 md:h-11 px-5 md:px-6 rounded-md bg-background-50 text-primary-700 text-sm font-semibold whitespace-nowrap hover:bg-accent-500 hover:text-background-50 transition-colors">
              查看详情
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>
      ))}

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(current - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 text-background-50 backdrop-blur hover:bg-background-50/50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(current + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 text-background-50 backdrop-blur hover:bg-background-50/50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute left-4 md:left-8 bottom-6 flex items-center gap-2">
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第${i + 1}张`}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${i === current ? 'w-8 bg-accent-500' : 'w-3 bg-background-50/50'}`}
          />
        ))}
      </div>
    </section>
  );
}